import { Walkthrough } from './walkthrough/Index'

const Personalization = () => {
    return (
        <Walkthrough/>
    )
}

export default Personalization